import { render, staticRenderFns } from "./TgToolbarBtn.vue?vue&type=template&id=1f08348a"
import script from "./TgToolbarBtn.vue?vue&type=script&lang=js"
export * from "./TgToolbarBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports